import usePTTMessageStore, { PTTMessage } from '../../api/usePttMessageStore';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Typography } from 'antd';
import { formatDateTime, normalizeTimestamp } from '../../helpers/formatDateTime';
import { formatTime } from '../../../../../utils/format';
import dayjs from 'dayjs';
import { useAuthStore } from '../../../../../store/auth/auth';
import { getDeviceName } from '../../helpers/giveDeviceName';
import { DeviceByGroupStore } from '../../../../../store/devices/DeviceByGroupStore';
import './styles.css';
export interface CurrentTarget {
    type: 'group' | 'device' | 'operator';
    name: string | undefined;
    id: string | undefined;
    online?: boolean;
    groupId?: string;
    groupName?: string;
    deviceDid?: string;
}
const { Text } = Typography;

function debounce(func: (...args: any[]) => void, wait: number) {
    let timeout: NodeJS.Timeout;
    return function executedFunction(...args: any[]) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

export const MessageList = ({
    currentTarget,
    user,
}: {
    currentTarget: CurrentTarget | null;
    user: any;
    chatContainerRef: React.RefObject<HTMLDivElement>;
}) => {
    const {
        messages,
        playQueue,
        isPlaying,
        currentPlayingId,
        markMessageAsPlayed,
        onPlaybackFinished,
        handleManualPlay,
        clearPlayQueue,
        setCurrentAudioElement,
        currentAudioElement,
        setIsPlaying,
        pauseCurrentAudio,
        setCurrentPlayingId,
        setIsManualPlaying,
        clearMessages,
    } = usePTTMessageStore();
    const bottomRef = useRef<HTMLDivElement | null>(null);
    const { SmartDVRToken } = useAuthStore();
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const { allDevices } = DeviceByGroupStore();
    const audioRefs = useRef<{ [key: string]: HTMLAudioElement | null }>({});
    // console.log(currentTarget);
    // Эффект для автоматического воспроизведения очереди
    useEffect(() => {
        // Если уже играет или ручное воспроизведение - ничего не делаем
        if (isPlaying || usePTTMessageStore.getState().isManualPlay) return;

        if (playQueue.length > 0) {
            const nextMessage = playQueue[0];

            // Если это сообщение УЖЕ играет (currentPlayingId) - не запускаем снова
            if (currentPlayingId === nextMessage.id) return;

            const audioElement = document.getElementById(
                `audio-${nextMessage.id}`,
            ) as HTMLAudioElement;

            if (audioElement) {
                setCurrentPlayingId(nextMessage.id);
                setIsPlaying(true);
                setCurrentAudioElement(audioElement);

                audioElement
                    .play()
                    .then(() => markMessageAsPlayed(nextMessage.id))
                    .catch(console.error);
            }
        }
    }, [playQueue]); // Зависимость только от playQueue

    // useEffect(() => {
    //     if (isPlaying && playQueue.length > 0 && !currentAudioElement) {
    //         const currentMessage = playQueue[0];
    //         const audioElement = document.getElementById(
    //             `audio-${currentMessage.id}`,
    //         ) as HTMLAudioElement;
    //
    //         if (audioElement) {
    //             setCurrentAudioElement(audioElement);
    //             audioElement
    //                 .play()
    //                 .then(() => markMessageAsPlayed(currentMessage.id))
    //                 .catch((error) => {
    //                     console.error('Playback failed:', error);
    //                     onPlaybackFinished();
    //                 });
    //         }
    //     }
    // }, [isPlaying, playQueue, currentAudioElement]);

    const conversationMessages = useMemo(() => {
        if (!currentTarget) return [];

        const targetIds = new Set(
            [currentTarget.id, currentTarget.groupId].filter(Boolean) as string[],
        );

        return messages
            .filter((message) => {
                // Для устройства: показываем входящие от него и исходящие к нему
                console.log(message);

                if (currentTarget.type === 'device') {
                    return (
                        ((message.recipient.type === 'operator' ||
                            message.recipient.type === 'device') &&
                            message.direction === 'incoming' &&
                            message.sender.id === currentTarget.id) ||
                        (message.direction === 'outgoing' &&
                            message.recipient.id === currentTarget.id)
                    );
                    // return (
                    //     (message.direction === 'incoming' &&
                    //         message.sender.id === currentTarget.id) ||
                    //     (message.direction === 'outgoing' &&
                    //         message.recipient.id === currentTarget.id)
                    // );
                }
                // Для групп
                else if (currentTarget.type === 'group') {
                    const messageGroupIds = [message.recipient.id, message.group?.uid].filter(
                        Boolean,
                    ) as string[];

                    return (
                        // (message.recipient.id === currentTarget.id &&
                        //     message.recipient.type === 'group') ||
                        // (message.sender.type === 'operator' &&
                        //     message.recipient.id === currentTarget.id)
                        message.recipient.type === 'group' &&
                        messageGroupIds.some((id) => targetIds.has(id))
                        // (message.recipient.name == currentTarget.name &&
                        //     message.recipient.type === 'group')
                    );
                }
                // else if (currentTarget.id === '00000000-0000-0000-0000-000000000000') {
                //     return (
                //         message.recipient.name === 'unsigned' && message.recipient.type === 'group'
                //     );
                // }

                return false;
            })
            .sort((a, b) => dayjs(a.timestamp).valueOf() - dayjs(b.timestamp).valueOf());
    }, [messages, currentTarget]);

    useEffect(() => {
        clearMessages();
    }, [currentTarget?.id]);

    // Обработчик воспроизведения аудио
    const handleAudioPlay = (messageId: string, audioElement: HTMLAudioElement) => {
        const store = usePTTMessageStore.getState();
        const isFromQueue = store.playQueue.some((m) => m.id === messageId);

        // Пауза текущего аудио
        if (store.currentAudioElement && store.currentAudioElement !== audioElement) {
            store.currentAudioElement.pause();
        }

        // Обновляем состояние
        store.setCurrentAudioElement(audioElement);
        store.setCurrentPlayingId(messageId);
        store.setIsPlaying(true);
        store.markMessageAsPlayed(messageId);

        if (!isFromQueue) {
            // Для ручного воспроизведения
            store.setIsManualPlaying(true);
            store.clearPlayQueue();
        }

        // // Если это сообщение из очереди и не ручное воспроизведение
        // const isFromQueue = playQueue.some((m) => m.id === messageId);
        // if (isFromQueue && !usePTTMessageStore.getState().isManualPlay) {
        //     return;
        // }
        //
        // // Пауза текущего аудио, если оно другое
        // if (currentAudioElement && currentAudioElement !== audioElement) {
        //     currentAudioElement.pause();
        // }
        //
        // // Обновляем состояние
        // setCurrentAudioElement(audioElement);
        // setIsPlaying(true);
        // setCurrentPlayingId(messageId);
        // markMessageAsPlayed(messageId);
        //
        // // Если это ручное воспроизведение - очищаем очередь
        // if (!isFromQueue) {
        //     setIsManualPlaying(true);
        //     clearPlayQueue();
        // }
    };

    // Обработчик паузы аудио
    const handleAudioPause = (messageId: string) => {
        const store = usePTTMessageStore.getState();

        if (store.currentPlayingId === messageId) {
            // Сбрасываем флаг ручного воспроизведения при паузе
            store.setIsManualPlaying(false);
            store.setIsPlaying(false);
            store.setCurrentPlayingId(null);
        }
    };

    // Обработчик окончания воспроизведения
    const handleAudioEnded = (messageId: string) => {
        if (currentPlayingId === messageId) {
            onPlaybackFinished();
        }
    };

    // Добавляем эффект для обработки окончания воспроизведения
    useEffect(() => {
        const { currentAudioElement } = usePTTMessageStore.getState();
        if (currentAudioElement) {
            const handleEnded = () => {
                usePTTMessageStore.getState().onPlaybackFinished();
            };
            currentAudioElement.addEventListener('ended', handleEnded);
            return () => {
                currentAudioElement.removeEventListener('ended', handleEnded);
            };
        }
    }, [currentAudioElement]);

    // 💡 Автоскролл вниз при любом новом сообщении
    useEffect(() => {
        if (bottomRef.current) {
            bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages.length, currentTarget?.id]);

    useEffect(() => {
        console.log(currentPlayingId);
    }, [currentPlayingId]);

    return (
        <>
            {conversationMessages?.map((message) => {
                const uniqueKey = `${message.id}-${message.timestamp}-${message.direction}`;
                const incomingOperator =
                    message.direction == 'incoming' && message.sender.type == 'operator';
                return (
                    <div
                        key={uniqueKey}
                        className={`audio-blob-container ${incomingOperator ? 'outgoing' : message.direction} ${
                            currentPlayingId === message.id ? 'playing' : ''
                        }`}
                    >
                        <div className="audio-blob">
                            <Text className={'title medium'} style={{ color: 'var(--gray-01)' }}>
                                {message.sender.name == 'Устройство не опознано'
                                    ? getDeviceName(allDevices, message.sender.id)?.name
                                    : message.sender.name}
                                {/*{currentlyPlayingId === message.id && (*/}
                                {/*    <span style={{ marginLeft: 8 }}>🔊</span>*/}
                                {/*)}*/}
                                <Text type="secondary" style={{ fontSize: 12, marginLeft: 8 }}>
                                    {formatDateTime(message.timestamp)}
                                </Text>
                            </Text>
                            {message.audioUrl || message.audioBlobUrl ? (
                                <audio
                                    // ref={(el) => (audioRefs.current[message.id] = el)}
                                    id={`audio-${message.id}`}
                                    controls
                                    src={message.audioBlobUrl || message.audioUrl}
                                    // onPlay={(e) => {
                                    //     const audioElement = e.currentTarget;
                                    //     if (!playQueue.some((m) => m.id === message.id)) {
                                    //         // Если сообщение не из очереди - очищаем очередь
                                    //         clearPlayQueue();
                                    //         setCurrentAudioElement(audioElement);
                                    //     }
                                    //     handleManualPlay(message.id);
                                    //     markMessageAsPlayed(message.id);
                                    // }}
                                    onPlay={(e) => {
                                        e.stopPropagation();
                                        handleAudioPlay(message.id, e.currentTarget);
                                    }}
                                    onPause={(e) => {
                                        e.stopPropagation();
                                        handleAudioPause(message.id);
                                    }}
                                    onEnded={() => handleAudioEnded(message.id)}
                                    // onEnded={() => {
                                    //     if (currentPlayingId === message.id) {
                                    //         setCurrentAudioElement(null);
                                    //         onPlaybackFinished();
                                    //     }
                                    // }}
                                    // onPause={() => {
                                    //     if (currentPlayingId === message.id) {
                                    //         setIsPlaying(false);
                                    //     }
                                    // }}
                                />
                            ) : (
                                <div>Не удалось загрузить аудио</div>
                            )}
                        </div>
                    </div>
                );
            })}
            {/*<audio*/}
            {/*    ref={audioRef}*/}
            {/*    onEnded={onPlaybackFinished}*/}
            {/*    onError={onPlaybackFinished}*/}
            {/*    style={{ display: 'none' }}*/}
            {/*/>*/}
            <div ref={bottomRef} />
        </>
    );
};
